// extracted by mini-css-extract-plugin
export var optionGrid = "_ak-7";
export var optionList = "_ak-6";
export var questionsBlock = "_ak-9";
export var spacer = "_ak-5";
export var stepCenteredContent = "_ak-3";
export var stepInner = "_ak-0";
export var stepInnerFullWidth = "_ak-1";
export var stepInnerLockScroll = "_ak-2";
export var stepTransitionFrame = "_ak-4";
export var welcomeBlock = "_ak-8";